import store from "../../../Store";
import { toggleURLQuery } from "../../../helpers/UrlHelper";
import getOrganizationUsers from "../../../ajax/actions/organization-user/users_get";

export function toggleOrganizationUserListFilter(e) {
  return function (dispatch) {
    let { name, value, id } = e.target;
    dispatch({ type: "TOGGLE-ORGANIZATION-USER-LIST-FILTER", name, value });
    // store.dispatch( getUsers());
    if (name === "limit") {
      store.dispatch(getOrganizationUsers(true));
    } else {
      store.dispatch(getOrganizationUsers(id, true));
    }
  };
}

export function setDefaultOrganizationUserFiltersToURL(history) {
  return (dispatch, getState) => {
    let { data } = getState().siteList;
    let { params } = data;
    Object.keys(params).map((key) => {
      if (
        params[key] !== `` &&
        params[key] !== null &&
        params[key] !== undefined
      ) {
        toggleURLQuery(key, params[key], history);
      }
    });
  };
}

export function resetSearchParams() {
  return function (dispatch) {
    dispatch({ type: "RESET-SEARCH-PARAMS" });
  };
}
